(function ($, Cobalt, undefined) {
    Cobalt.Utils = {
        disable: function (jQueryElement) {
            $(jQueryElement).addClass("disabled");
            $(jQueryElement).on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();

                return false;
            });
        },
        isUrlCurrentSite: function (url) {
            var siteRoot = "http://" + window.location.host;
            var secureSiteRoot = "https://" + window.location.host;
            return url.indexOf(siteRoot + "/") === 0
                || url.indexOf(secureSiteRoot + "/") === 0
                || (url.indexOf("/") === 0 && url.indexOf("//") !== 0)
                || url === siteRoot
                || url === secureSiteRoot;
        },
        getCurrentDomain: function () {
            var host = self.location.host;
            var segments = host.split(".");
            var tld = segments[segments.length - 2] + "." + segments[segments.length - 1];
            return tld;
        },
        getStaticDomain: function () {
            return "http://static." + Cobalt.Utils.getCurrentDomain();
        },
        cookiesDisabled: function () {
            var options = { domain: Cobalt.Utils.getCurrentDomain(), path: "/" };
            $.cookie("_cookieTest", true, options);
            var cookie = $.cookie("_cookieTest");
            $.cookie("_cookieTest", null, options);
            return (cookie == null);
        },
        getSlug: function (stringToSlug) {
            stringToSlug = stringToSlug.toLowerCase();
            while (stringToSlug.match(/[^A-Za-z0-9_\-\s]+/) != null) {
                stringToSlug = stringToSlug.replace(/[^A-Za-z0-9_\-\s]/, "");
            }
            var slug_array = stringToSlug.split(" ");
            stringToSlug = slug_array.join("-");
            return stringToSlug;
        },
        getCookieValues: function (cookie) {
            if (cookie == null) {
                return null;
            } else {
                var values = {};
                var pairs = cookie.split("&");
                for (var i = 0; i < pairs.length; i++) {
                    var pair = pairs[i];
                    var equalsPosition = pair.indexOf("=");
                    var key, value;
                    if (equalsPosition == -1) {
                        key = pair;
                        value = "";
                    } else {
                        key = pair.substring(0, equalsPosition);
                        value = pair.substring(equalsPosition + 1);
                    }
                    value = unescape(value);
                    try {
                        value = JSON.parse(value);
                    } catch (exc) {
                        value = null;
                    }
                    values[key] = value;
                }
                return values;
            }
        },
        serializeCookieValues: function (values) {
            var serialized = [];
            var keys = [];
            for (var key in values) {
                keys.push(key);
            }
            keys.sort();
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key && (key != null && typeof key != "undefined")) {
                    serialized.push(key + "=" + encodeURIComponent(JSON.stringify(values[key])));
                }
            }
            return serialized.join("&");
        },
        objectToQueryString: function (target, excludeStart) {
            if (target == undefined || target.constructor !== Object) {
                return "";
            }
            var keys = [];
            for (var key in target) {
                keys.push(key);
            }
            keys.sort();
            var queryString = [];
            for (var i = 0; i < keys.length; i++) {
                queryString.push(i == 0 ? "?" : "&");

                var key = keys[i];
                queryString.push(encodeURIComponent(key));
                queryString.push("=");
                queryString.push(encodeURIComponent(target[key]));
            }
            if (excludeStart) {
                queryString.shift();
            }
            return queryString.join("");
        },
        queryStringToObject: function () {
            var length = location.search.length;
            if (length > 0) {
                var fullQueryString = location.search.substring(1, length);
                var keyValuePairs = fullQueryString.split('&');
                var result = new Object();
                for (var i = 0; i < keyValuePairs.length; i++) {
                    var kvp = keyValuePairs[i].split('=');
                    result[kvp[0]] = kvp[1];
                }
                return result;
            }
            return {};
        },
        removeFromQueryString: function (key) {
            var length = location.search.length;
            if (length > 0) {
                var fullQueryString = location.search.substring(1, length);
                var keyValuePairs = fullQueryString.split('&');
                var result = new Object();
                for (var i = 0; i < keyValuePairs.length; i++) {
                    var kvp = keyValuePairs[i].split('=');
                    if (kvp[0] == key) {
                        continue;
                    }
                    result[kvp[0]] = kvp[1];
                }
                return Cobalt.Utils.objectToQueryString(result);
            }
            return "";
        },
        getQueryStringValue: function(key) {
            var length = location.search.length;
            if (length === 0) {
                return "";
            }

            var query = location.search.replace("?", "");
            var queries = query.split("&");
            var kvp = queries.find(function(q) {
                return q.indexOf(key) > -1;
            });

            
            if (!kvp || kvp.indexOf("=") === -1) {
                return "";
            }

            return kvp.split("=")[1];
        },
        confirmDelete: function (url, message, obj, e, type) {
            e.preventDefault();

            if (!confirm(message)) {
                return;
            }

            Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                var tagName = obj[0].tagName;
                var form = obj.parents('form:first');
                //if this is a button thats part of a form, just click it, no need to post
                if (form.length && tagName == "BUTTON") {
                    obj.unbind("click");
                    obj.click();
                    return false;
                }

                if (obj.attr("data-show-loading") !== undefined) {
                    obj.addClass("loading");
                }

                if (type === "no-reload") {
                    Cobalt.Forms.AjaxPostSubmit(obj, token).done(function (result) {
                        if (result !== undefined && result.redirectURL !== undefined) {
                            window.location = result.redirectURL;
                        } else {
                            $(obj).trigger('deleteConfirmPost');
                        }
                    });
                }
                else if (type === "no-ajax") {
                    window.location = url;
                }
                else {
                    Cobalt.Forms.AjaxPostSubmit(obj, token).done(function (result) {
                        if (result != null && result.errorMessage != null) {

                            var div = $("<div><div>" + result.errorMessage + "</div></div>");
                            div.dialog({
                                draggable: false,
                                title: "Unable to Delete",
                                modal: true,
                                resizable: false,
                                dialogClass: 'modal'
                            });

                        }
                        else {
                            window.location.reload();
                        }
                        return false;
                    });
                }
                return false;
            });
        },
        setPromptHidden: function ($this) {
            var showLink = $("<a>").text("Click to show Auto Hidden Content").addClass("hidden-prompt-link");
            showLink.click(function () {
                $(this).next().show().removeClass("hide");
                $(this).remove();
            });
            $this.before(showLink);

        },
        setPrompt: function ($this) {
            var message = $this.attr("data-prompt-message");
            $this.click(function (e) {
                if (!confirm(message)) {
                    e.preventDefault();
                    return;
                }
            });

        },
        setConfirmDelete: function ($this) {
            var message = $this.attr("data-delete-prompt-message");
            var type = $this.attr("data-delete-type");
            var url = $this.attr("href");

            if (message == "" || message == null) {
                message = $this.parent().attr("data-delete-prompt-message");
                if (message == "" || message == null) {
                    message = "Delete?";
                }
            }

            if (url != "" && message != "") {
                $this.unbind("click");

                $this.bind('click', function (e) {
                    Cobalt.Utils.confirmDelete(url, message, $this, e, type);

                    return false;
                });
            }
        },
        getRequestVerificationToken: function () {
            var token = $.cookie("RequestVerificationToken");
            if (!token) {
                return $.ajax({
                    url: "/refresh-request-verification-token",
                    type: 'POST',
                    dataType: 'json',
                }).pipe(function () {
                    return $.cookie("RequestVerificationToken");
                });
            }
            else {
                return $.Deferred().resolve(token);
            }
        },        
        postWithToken: function (url, dataObject) {
            /// <summary>Adds the request verification token to a data object and POSTs it to the provided url and returns a jquery Deferred.</summary>
            /// <param name="dataObject">Simple object that contains the fields to POST. This should be an object and not a string</param>
            dataObject = dataObject || {};
            return Cobalt.Utils.getRequestVerificationToken().pipe(function (token) {
                dataObject["request-verification-token"] = token;                                                
                $.post(url, dataObject);
            });            
        },
        postNewFormWithToken: function (url, dataObject) {
            /// <summary>Adds the request verification token to a data object, creates a new POST form, and submits it. Returns a jquery Deferred.</summary>
            /// <param name="dataObject">Simple object that contains the fields to POST. This should be an object and not a string.</param>
            dataObject = dataObject || {};
            return Cobalt.Utils.getRequestVerificationToken().pipe(function (token) {
                dataObject["request-verification-token"] = token;

                var form = document.createElement('form');
                form.method = 'post';
                form.action = url;
                for (var key in dataObject) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = dataObject[key];
                    form.appendChild(input);
                }
                document.body.appendChild(form);
                form.submit();
            });            
        },
        getRequestVerificationTokenElement: function () {
            return Cobalt.Utils.getRequestVerificationToken().pipe(function(token) {
                return "<input name=\"request-verification-token\" type=\"hidden\" value=\"" + token + "\" />";
            });
        }
    };

    $.fn.setCursorPosition = function (pos) {
        if ($(this).get(0).setSelectionRange) {
            $(this).get(0).setSelectionRange(pos, pos);
        } else if ($(this).get(0).createTextRange) {
            var range = $(this).get(0).createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    };

    $.fn.getCursorPosition = function () {
        var pos = 0;
        var el = $(this).get(0);
        // IE Support
        if (document.selection) {
            el.focus();
            var sel = document.selection.createRange();
            var selLength = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            pos = sel.text.length - selLength;
        }
            // Firefox support
        else if (el.selectionStart || el.selectionStart == '0')
            pos = el.selectionStart;

        return pos;
    };

    $.log = function (message) {
        if (window.console) {
            console.log(message);
        }
    };

    $.debug = function (message) {
        if (window.console) {
            console.debug(message);
        }
    };

    $.info = function (message) {
        if (window.console) {
            console.info(message);
        }
    };

    $.warn = function (message) {
        if (window.console) {
            console.warn(message);
        }
    };

    $.error = function (message) {
        if (window.console) {
            console.error(message);
        }
    };

    $.group = function (name, func, collapsed) {
        if (window.console && console.group && console.groupCollapsed) {
            if (collapsed) {
                console.groupCollapsed(name);
            }
            else {
                console.group(name);
            }

            if (func) {
                func();
                console.groupEnd();
            }
        }
    }

    $.endGroup = function () {
        if (window.console && console.groupEnd) {
            console.groupEnd();
        }
    }
})($, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Utils.js